import { createReactBlockSpec } from "@blocknote/react";
import { useContext, useState } from "react";
import type { PersistedForm } from "schemas";
import { BlocksContext } from "../../BlocksContext";
import { FormLinkBlock } from "./FormLinkBlock";

export const FormLinkBlockSpec = createReactBlockSpec(
  {
    type: "formLinkBlock",
    propSchema: {
      formId: {
        default: "",
      },
      url: {
        default: "",
      },
      label: {
        default: "",
      },
      buttonTextColor: {
        default: "",
      },
      buttonBackgroundColor: {
        default: "",
      },
      buttonTextAlignment: {
        values: ["Center", "Default"],
        default: "Default",
      },
      buttonBorderRadius: {
        values: ["Rounded", "Smooth", "Square"],
        default: "",
      },
    },
    content: "none", // No editable content needed
    isSelectable: true,
  },
  {
    render: ({
      editor,
      block: {
        id,
        props: { formId, label, url, buttonTextColor, buttonBackgroundColor, buttonBorderRadius, buttonTextAlignment },
      },
    }) => {
      const { FormLinkBlockDrawer } = useContext(BlocksContext);
      const [showDrawer, setShowDrawer] = useState(!formId);

      const handleCloseDrawer = () => {
        // If the user closes the drawer without selecting a form,
        // remove the empty block
        if (!formId) {
          editor.removeBlocks([id]);
        }
        setShowDrawer(false);
      };

      const handleFormSelected = (form: PersistedForm) => {
        editor.updateBlock(id, {
          props: {
            formId: form.id,
            url: form.url,
            label: form.name,
            // biome-ignore lint/suspicious/noExplicitAny:
          } as any,
        });
        editor.setTextCursorPosition(id);
        setShowDrawer(false);
      };

      // If form ID is empty, show the drawer to select a form
      if (showDrawer) {
        return <FormLinkBlockDrawer onClose={handleCloseDrawer} onFormSelected={handleFormSelected} />;
      }

      return (
        <FormLinkBlock
          label={label}
          url={url}
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
          buttonBorderRadius={buttonBorderRadius}
          buttonTextAlignment={buttonTextAlignment}
        />
      );
    },
  },
);
